// !!! 注意! 只在 packages/shared 中修改

// https://lanhuapp.com/web/#/item/project/board/detail?pid=3c7f00fd-7a0c-4f41-a79c-2e75be088426&project_id=3c7f00fd-7a0c-4f41-a79c-2e75be088426&image_id=995e602d-06de-4685-be8a-d7595f8687d8
/**
 * 常用的ui提供的图片
 * @hz/shared - 统一的图片常量配置
 */
// 结果页：成功时用彩图COLOR,失败时用灰图GRAY。加载时用灰图GRAY。
const result = {
    // 内容已下架
    IMAGE_GRAY_NOTHING: 'https://oss-resource668.yzdli.com/website/image/result/pic_nothing.png',
    // 无内容
    IMAGE_GRAY_CONTENT: 'https://oss-resource668.yzdli.com/website/image/result/pic_content.png',
    //   支付成功
    IMAGE_GRAY_PAY: 'https://oss-resource668.yzdli.com/website/image/result/result_pic_pay.png',
    //   会员购买成功
    IMAGE_GRAY_VIP: 'https://oss-resource668.yzdli.com/website/image/result/result_pic_vip.png',
};

const home = {
    iconCaigje: 'https://oss-resource668.yzdli.com/website/image/home/home_icon_caigje@2x.webp',
    iconYaoykh: 'https://oss-resource668.yzdli.com/website/image/home/home_icon_yaoykh@2x.webp',
    iconYouhq: 'https://oss-resource668.yzdli.com/website/image/home/home_icon_youhq@2x.webp',
    iconGuanzrc: 'https://oss-resource668.yzdli.com/website/image/home/home_icon_guanzrc@2x.webp',
    iconToubj: 'https://oss-resource668.yzdli.com/website/image/home/home_icon_toubj@2x.webp',
    homeIconYunzxt: 'https://oss-resource668.yzdli.com/website/image/home/home_icon_yunzxt@2x.webp',
    iconYunsj: 'https://oss-resource668.yzdli.com/website/image/home/me_icon_yunsj@2x.webp',
    iconYunhz: 'https://oss-resource668.yzdli.com/website/image/home/me_icon_yunhz@2x.webp',
    iconYunzb: 'https://oss-resource668.yzdli.com/website/image/home/home_icon_yunzb@2x.webp',
    iconYuncg: 'https://oss-resource668.yzdli.com/website/image/home/home_icon_yuncg@2x.webp',
    iconYunzs: 'https://oss-resource668.yzdli.com/website/image/home/home_icon_yunzs@2x.png',
};

// VIP等级图标
const vipLevel = {
    VIP_LEVEL1: 'https://oss-resource668.yzdli.com/website/image/icon/vipLevel/level1.png',
    VIP_LEVEL2: 'https://oss-resource668.yzdli.com/website/image/icon/vipLevel/level2.png',
    VIP_LEVEL3: 'https://oss-resource668.yzdli.com/website/image/icon/vipLevel/level3.png',
    VIP_LEVEL4: 'https://oss-resource668.yzdli.com/website/image/icon/vipLevel/level4.png',
    VIP_LEVEL5: 'https://oss-resource668.yzdli.com/website/image/icon/vipLevel/level5.png',
    // 热度的按钮
    ICON_HOT: 'https://oss-resource668.yzdli.com/website/image/icon/vipLevel/icon_hot.png',
    // VIP介绍
    // VIP_INTRODUCTION_0: 'https://oss-resource668.yzdli.com/website/image/icon/vipLevel/introduction0.png',
    // VIP_INTRODUCTION_1: 'https://oss-resource668.yzdli.com/website/image/icon/vipLevel/introduction1.png',
    // VIP_INTRODUCTION_2: 'https://oss-resource668.yzdli.com/website/image/icon/vipLevel/introduction2.png',
    // VIP_INTRODUCTION_3: 'https://oss-resource668.yzdli.com/website/image/icon/vipLevel/introduction3.png',
    // VIP_INTRODUCTION_4: 'https://oss-resource668.yzdli.com/website/image/icon/vipLevel/introduction4.png',
    // VIP_INTRODUCTION_5: 'https://oss-resource668.yzdli.com/website/image/icon/vipLevel/introduction5.png',
    // 新版介绍
    VIP_INTRODUCTION_0: 'https://oss-resource668.yzdli.com/website/activity/recommend/img1.png',
    VIP_INTRODUCTION_1: 'https://oss-resource668.yzdli.com/website/activity/recommend/img_2.png',
    VIP_INTRODUCTION_2: 'https://oss-resource668.yzdli.com/website/activity/recommend/Frame 167.png',
    VIP_INTRODUCTION_3: 'https://oss-resource668.yzdli.com/website/activity/recommend/img1.png',
    VIP_INTRODUCTION_4: 'https://oss-resource668.yzdli.com/website/activity/recommend/Frame 170.png',
    VIP_INTRODUCTION_5: 'https://oss-resource668.yzdli.com/website/activity/recommend/Frame 155.png',

    // 后面+01.jpeg 到 32.JPEG
    VIP_LEVEL_COMPANY_LOGO: 'https://oss-resource668.yzdli.com/website/image/icon/vipLevel/companyLogo/',
    VIP_LEVEL_BG: 'https://oss-resource668.yzdli.com/website/image/icon/vipLevel/huiy_pic_bj.jpeg',

    /**
     * 3.52开始, 只有个人版, 基础版, 商务版,  旗舰版, 元宇宙版
     * 3.52  旧版本的基础版全都换成商务版
     */
    VIP_LEVEL_0: 'https://oss-resource668.yzdli.com/website/image/icon/vipLevel/badge_profile.png',

    VIP_LEVEL_1: 'https://oss-resource668.yzdli.com/website/image/icon/vipLevel/badge_shangwuban.png',
    VIP_LEVEL_2: 'https://oss-resource668.yzdli.com/website/image/icon/vipLevel/badge_shangwuban.png',
    VIP_LEVEL_3: 'https://oss-resource668.yzdli.com/website/image/icon/vipLevel/badge_shangwuban.png',
    VIP_LEVEL_4: 'https://oss-resource668.yzdli.com/website/image/icon/vipLevel/badge_shangwuban.png',
    VIP_LEVEL_5: 'https://oss-resource668.yzdli.com/website/image/icon/vipLevel/badge_shangwuban.png',

    VIP_LEVEL_6: 'https://oss-resource668.yzdli.com/website/image/icon/vipLevel/badge_shangwuban.png',
    VIP_LEVEL_7: 'https://oss-resource668.yzdli.com/website/image/icon/vipLevel/badge_qijianban.png',
    VIP_LEVEL_8: 'https://oss-resource668.yzdli.com/website/image/icon/vipLevel/badge_metauniverse.png',

    // 对按钮
    ICON_YES: 'https://oss-resource668.yzdli.com/website/image/icon/icon_yellow_yes.png',
    ICON_YES2: 'https://oss-resource668.yzdli.com/website/image/icon/icon_yellow_yes2.jpg',
    ICON_YELLOW_CONTRACTORS: 'https://oss-resource668.yzdli.com/website/image/icon/icon_yellow_contractors.png',
    ICON_YELLOW_SPONSOR: 'https://oss-resource668.yzdli.com/website/image/icon/icon_yellow_sponsor.png',
    ICON_YELLOW_DESIGNER: 'https://oss-resource668.yzdli.com/website/image/icon/icon_yellow_designer.png',
};

const defaults = {
    DEFAULTS_AVATAR: 'https://oss-resource668.yzdli.com/website/image/default/default-avatar.png',
    // 较大
    DEFAULTS_AVATAR_BIG: 'https://oss-resource668.yzdli.com/website/image/default/com_user_b.png',
    DEFAULTS_COMPANY_ICON: 'https://oss-resource668.yzdli.com/website/image/icon/iconcompany-fill.png',
    INVITE_POSTER_BG: 'https://oss-resource668.yzdli.com/website/image/default/invitePosterBg.jpg',
    INVITE_POSTER_BG_2022:
        'https://resource668.oss-cn-shenzhen.aliyuncs.com/website/image/default/jfdfjlskdfjlaskdfjlksadfjoksdf454352.jpg',
    // 选择语言框的选择按钮背景
    CHOOSE_EDIT_LANG_BTN: 'https://oss-resource668.yzdli.com/website/image/default/chooseEditLangBtn.jpg',
    // 选择语言框的标题的背景
    MODAL_TITLE_BG: 'https://oss-resource668.yzdli.com/website/image/default/pic_wenxts@2x.png',
    SUPPLY_CHAIN_CHNAP: 'https://oss-resource668.yzdli.com/website/image/icon/icon_supplyChain_chnap.png',
    SUPPLY_CHAIN_LANG: 'https://oss-resource668.yzdli.com/website/image/icon/icon_supplyChain_lang.png',
    SUPPLY_CHAIN_QIYE: 'https://oss-resource668.yzdli.com/website/image/icon/icon_supplyChain_qiye.png',
    SUPPLY_CHAIN_VR: 'https://oss-resource668.yzdli.com/website/image/icon/icon_supplyChain_vr.png',
};

// 成功icon
const success = {
    IMAGE_RESULT_FORM: 'https://oss-resource668.yzdli.com/website/image/success/form.png',
};

const icon = {
    ICON_MILITARY_EMBLEM: 'https://oss-resource668.yzdli.com/website/image/icon/icon_military_emblem.png',
    ICON_HONGBAO: 'https://oss-resource668.yzdli.com/website/image/default/pic_hongb.png',
    IMAGE_HUODONG_BG: 'https://oss-resource668.yzdli.com/website/image/default/yaoq_pic_huodong.png',
    ICON_YAOXJL: 'https://oss-resource668.yzdli.com/website/image/default/pic_yaoxjl.jpg',
    ICON_QIANBAO_ICON: 'https://oss-resource668.yzdli.com/website/image/icon/qianb_pic_qianbao.png',
    ICON_HOT_GIF: 'https://oss-resource668.yzdli.com/website/image/default/hot.gif',
    ICON_GOLD_COMPANY: 'https://oss-resource668.yzdli.com/website/image/icon/icon_gold_company.png',
    ICON_GRAY_COMPANY: 'https://oss-resource668.yzdli.com/website/image/icon/icon_gray_company.png',
    // 个人按钮
    ICON_GOLD_PEOPLE: 'https://oss-resource668.yzdli.com/website/image/icon/icon_gold_people.png',
    ICON_GRAY_PEOPLE: 'https://oss-resource668.yzdli.com/website/image/icon/icon_gray_people.png',
    ICON_GRIANGLE_GREEN: 'https://oss-resource668.yzdli.com/website/image/icon/icon_triangle_green.png',
    ICON_GRIANGLE_RED: 'https://oss-resource668.yzdli.com/website/image/icon/icon_triangle_red.png',
    // 坐标地址
    IMAGE_ADDRESS: 'https://oss-resource668.yzdli.com/website/image/icon/icon_address.png',
    IMAGE_LOADING: 'https://oss-resource668.yzdli.com/website/image/default/spinner.gif',
    MINI_CHART1: 'https://oss-resource668.yzdli.com/website/image/default/miniChat1.png',
    MINI_CHART2: 'https://oss-resource668.yzdli.com/website/image/default/miniChat2.png',
    MINI_CHART3: 'https://oss-resource668.yzdli.com/website/image/default/miniChat3.png',
    MINI_CHART4: 'https://oss-resource668.yzdli.com/website/image/default/miniChat4.png',
    IMAGE_ICON_NODATA: 'https://oss-resource668.yzdli.com/website/image/icon/result_pic_nodata.png',
    IMAGE_ICON_NOTIFICATIONS: 'https://oss-resource668.yzdli.com/website/image/icon/notifications-center.png',
    IMAGE_ICON_BELL: 'https://oss-resource668.yzdli.com/website/image/icon/icon_bell_yellow.png',
    IMAGE_ICON_MAIL: 'https://oss-resource668.yzdli.com/website/image/icon/icon_mail_blue.png',
    ICON_REGISTER_CANZHAN: 'https://oss-resource668.yzdli.com/website/image/icon/register_canzhan.png',
    ICON_REGISTER_ZHUBAN: 'https://oss-resource668.yzdli.com/website/image/icon/register_zhuban.png',
    ICON_REGISTER_FUWUSHANG: 'https://oss-resource668.yzdli.com/website/image/icon/register_fuwushang.png',
    ICON_WENXIN: 'https://oss-resource668.yzdli.com/website/image/icon/icon_weixin.png',
    // ICON_3DBZ: 'https://oss-resource668.yzdli.com/website/image/icon/3dbz.png',
    ICON_COLLECT: 'https://oss-resource668.yzdli.com/website/image/icon/shoucang.png',
    ICON_NOW_TIME_DATA: 'https://oss-resource668.yzdli.com/website/image/icon/ssshuju.png',
    ICON_EN_NOW_TIME_DATA: 'https://oss-resource668.yzdli.com/website/image/icon/ssshuju_en.png',
    ICON_NOW_TIME_DATA_227: 'https://oss-resource668.yzdli.com/website/image/icon/ssshuju_227.png?v=3',
    ICON_EN_NOW_TIME_DATA_227: 'https://oss-resource668.yzdli.com/website/image/icon/ssshuju_en.png',
    ICON_3D_COMPANY: 'https://oss-resource668.yzdli.com/website/image/icon/3Dcompany.png',
    ICON_ZHU_YE: 'https://oss-resource668.yzdli.com/website/image/icon/zhuye.png',
    ICON_NEW: 'https://oss-resource668.yzdli.com/website/image/icon/new.png',
    ICON_ERROR_VIDEO: 'https://oss-resource668.yzdli.com/website/image/icon/error_pic_video-01.png',
    ICON_SMART_SEARCH: 'https://oss-resource668.yzdli.com/website/image/icon/smart_search.png',
    ICON_SEARCH_GRAY: 'https://oss-resource668.yzdli.com/website/image/icon/icon_search_gray.png',
    ICON_PREVIEW: 'https://oss-resource668.yzdli.com/website/image/icon/preview.png',
    ICON_IMPORT: 'https://oss-resource668.yzdli.com/website/image/icon/icon_import.png',
    ICON_CLOSE: 'https://oss-resource668.yzdli.com/website/image/icon/close.png',
    ICON_LINK: 'https://oss-resource668.yzdli.com/website/image/icon/icon_link.png',
    ICON_SHARE: 'https://oss-resource668.yzdli.com/website/image/icon/icon_share.png',
    ICON_SHARE_SHADOW: 'https://oss-resource668.yzdli.com/website/image/icon/icon_share_shadow.png',
    ICON_SHARE_GRAY: 'https://oss-resource668.yzdli.com/website/image/icon/icon_share_gray.png',
    ICON_SHARE_FFF: 'https://oss-resource668.yzdli.com/website/image/icon/icon_share_fff.png',
    ICON_LOCK_FFF: 'https://oss-resource668.yzdli.com/website/image/icon/icon_lock.png',
    ICON_CERTIFICATE: 'https://oss-resource668.yzdli.com/website/image/icon/icon_certificate.png',
    // 企业工商
    ICON_GONGSHANG: 'https://oss-resource668.yzdli.com/website/image/icon/icon_gongshang.png',
    ICON_SWITCH: 'https://oss-resource668.yzdli.com/website/image/icon/icon_switch.png',
    ICON_MSG: 'https://oss-resource668.yzdli.com/website/image/icon/icon_msg.png',
    ICON_RIGHT: 'https://oss-resource668.yzdli.com/website/image/icon/icon_right.png',
    // 公司官网
    ICON_OFFICIAL_WEBSITE: 'https://oss-resource668.yzdli.com/website/image/icon/officialWebsite.png',
    ICON_VIDEO_PLAY: 'https://oss-resource668.yzdli.com/website/image/icon/video-play.png',
    ICON_B_PLAY: 'https://oss-resource668.yzdli.com/website/image/icon/b_play.png',
    // 带三点的红色洽谈按钮
    ICON_CHAT_DOT_RED: 'https://oss-resource668.yzdli.com/website/image/icon/icon_chat_dot_red.png',
    // 企业名片的icon
    ICON_MP_PRESS: 'https://oss-resource668.yzdli.com/website/image/icon/icon_mp_press.png',
    // 音视频接通按钮
    ICON_CHAT_HANGUP: 'https://oss-resource668.yzdli.com/website/image/icon/icon_chat_hangUp.png',
    // 音视频挂断按钮
    ICON_CHAT_CONNECT: 'https://oss-resource668.yzdli.com/website/image/icon/icon_chat_connect.png',
    // 购买短信套餐标识
    ICON_VIP_CHOICE: 'https://oss-resource668.yzdli.com/website/image/icon/icon_vip_Choice.png',
    // 发送普通邀约
    ICON_ENTER_SMS: 'https://oss-resource668.yzdli.com/website/image/icon/icon_enter_sms.png',
    // 发送多媒体邀约
    ICON_ENTER_FULL: 'https://oss-resource668.yzdli.com/website/image/icon/icon_enter_full.png',
    // 云展按钮
    ICON_YUNZH_TAG: 'https://oss-resource668.yzdli.com/website/image/default/yunzhTag.png?v=3',
    // 我是主办商按钮
    ICON_FUWS: 'https://oss-resource668.yzdli.com/website/image/default/pic_fuws.png',
    // 我是服务商按钮
    ICON_ZHUBS: 'https://oss-resource668.yzdli.com/website/image/default/pic_zhubs.png',
    ICON_MY_DATA_CHA_KAN: 'https://oss-resource668.yzdli.com/website/image/icon/icon_myData_chakan.svg',
    ICON_MY_DATA_DIAN_ZAN: 'https://oss-resource668.yzdli.com/website/image/icon/icon_myData_dianzan.svg',
    ICON_MY_DATA_SHARE: 'https://oss-resource668.yzdli.com/website/image/icon/icon_myData_share.svg',
    ICON_MY_DATA_ZHUAN_FA: 'https://oss-resource668.yzdli.com/website/image/icon/icon_myData_zhuanfa.svg',
    ICON_MY_DATA_QI_YE_HK: 'https://oss-resource668.yzdli.com/website/image/icon/pic_qiyehk@2x.png',
    ICON_MY_DATA_WEI_GEN_JIN: 'https://oss-resource668.yzdli.com/website/image/icon/pic_weigenjin@2x.png',
    ICON_MY_DATA_YI_GEN_JIN: 'https://oss-resource668.yzdli.com/website/image/icon/pic_yigenjin@2x.png',
    ICON_MY_DATA_YUAN_GFX: 'https://oss-resource668.yzdli.com/website/image/icon/pic_yuangfx@2x.png',
    ICON_QI_YE_REN_ZHENG: 'https://oss-resource668.yzdli.com/website/image/icon/icon_renzheng@2x.png',
    ICON_BIAN_GEN: 'https://oss-resource668.yzdli.com/website/image/icon/icon_biangeng@2x.png',
};

// 占位图
const occupied = {
    OCCUPIED_CONTENT: 'https://oss-resource668.yzdli.com/website/image/occupied/pic_content.png',
    OCCUPIED_MODEL: 'https://oss-resource668.yzdli.com/website/image/occupied/model.png',
    OCCUPIED_PRODUCT: 'https://oss-resource668.yzdli.com/website/image/occupied/product.png',
    OCCUPIED_SCENES: 'https://oss-resource668.yzdli.com/website/image/occupied/com_perch_view.png',
    OCCUPIED_COMPANY: 'https://oss-resource668.yzdli.com/website/image/occupied/com_perch_office.png',
    OCCUPIED_LIVE: 'https://oss-resource668.yzdli.com/website/image/occupied/com_perch_live.png',
    // 名片夹为空
    EMPTY_CARD_LIST: 'https://oss-resource668.yzdli.com/website/image/success/emptyCard.png',
};
// logo
const logo = {
    LOGO: 'https://oss-resource668.yzdli.com/website/image/logo/logo.png?v=2',
    LOGO_UP_DOWN: 'https://oss-resource668.yzdli.com/website/image/logo/pc_logo_lite.jpg',
    LOGO_SMALL: 'https://oss-resource668.yzdli.com/website/image/logo/logo-small.png',
    PIC_LOGO: 'https://resource668.oss-cn-shenzhen.aliyuncs.com/website/image/logo/pic_logo.png',
};
const qrcode = {
    // 云展动力APP下载地址
    APP_DOWNLOAD: 'https://oss-resource668.yzdli.com/website/QRcode/app_download.png?v=3',
    AI_SYSTEM_IMAGE: 'https://oss-resource668.yzdli.com/website/QRcode/aiSystemHome.jpg',
};
const operation = {
    LIVE_PAGE: 'https://oss-resource668.yzdli.com/website/operation/live_qrcode.jpg',
};

const bg = {
    NAMECARD_BG: 'https://oss-resource668.yzdli.com/website/image/bg/namecard_bg.jpg',
    NAMECARD_LOGO: 'https://oss-resource668.yzdli.com/website/image/bg/namecard_logo.png',
    LOGIN_BG: 'https://oss-resource668.yzdli.com/website/image/bg/loginBg.jpg',
};

// 缺省页
const defaultPage = {
    // 子账号已满
    DEFAULTPAGE_ZZH: 'https://oss-resource668.yzdli.com/defaultPage/pic_wmingp.png',
    // 暂无数据/暂无内容
    DEFAULTPAGE_SJNR: 'https://oss-resource668.yzdli.com/defaultPage/pic_wusj.png',
    // 暂无洽谈
    DEFAULTPAGE_QT: 'https://oss-resource668.yzdli.com/defaultPage/pic_wqiat.png',
    // 网络异常
    DEFAULTPAGE_WLYC: 'https://oss-resource668.yzdli.com/defaultPage/pic_wanglyc.png',
    // 暂无名片
    DEFAULTPAGE_MP: 'https://oss-resource668.yzdli.com/defaultPage/pic_wump.png',
    // 暂无优惠券
    DEFAULTPAGE_YHQ: 'https://oss-resource668.yzdli.com/defaultPage/pic_wuyhq.png',
    // 暂无记录
    DEFAULTPAGE_JL: 'https://oss-resource668.yzdli.com/defaultPage/pic_wjil.png',
    // 暂无收藏
    DEFAULTPAGE_SC: 'https://oss-resource668.yzdli.com/defaultPage/pic_wusc.png',


    //supplyV2
    DEFAULTPAGE_GYS: 'https://oss-resource668.yzdli.com/website/image/supplyV2/empty/pic_gys.png',
    DEFAULTPAGE_WLYC: 'https://oss-resource668.yzdli.com/website/image/supplyV2/empty/pic_wanglyc.png',
    DEFAULTPAGE_JL: 'https://oss-resource668.yzdli.com/website/image/supplyV2/empty/pic_wjil.png',
    DEFAULTPAGE_WMINGP: 'https://oss-resource668.yzdli.com/website/image/supplyV2/empty/pic_wmingp.png',
    DEFAULTPAGE_WQIAT: 'https://oss-resource668.yzdli.com/website/image/supplyV2/empty/pic_wqiat.png',
    DEFAULTPAGE_WUMP: 'https://oss-resource668.yzdli.com/website/image/supplyV2/empty/pic_wump.png',
    DEFAULTPAGE_WUSC: 'https://oss-resource668.yzdli.com/website/image/supplyV2/empty/pic_wusc.png',
    DEFAULTPAGE_WUSJ: 'https://oss-resource668.yzdli.com/website/image/supplyV2/empty/pic_wusj.png',
    DEFAULTPAGE_WUYHQ: 'https://oss-resource668.yzdli.com/website/image/supplyV2/empty/pic_wuyhq.png',
    DEFAULTPAGE_XIAJIA: 'https://oss-resource668.yzdli.com/website/image/supplyV2/empty/pic_xiajia.png',
};

module.exports = {
    ...defaults,
    ...result,
    ...home,
    ...success,
    ...icon,
    ...occupied,
    ...logo,
    ...qrcode,
    ...operation,
    ...bg,
    ...vipLevel,
    ...defaultPage,
};
